// general-product.js

document.addEventListener('DOMContentLoaded', () => {

  /* IMAGE SWITCH */

  const thumbs = document.querySelectorAll('.gp-thumb');
  const mainImage = document.getElementById('GPMainImage');

  thumbs.forEach((thumb) => {

    thumb.addEventListener('click', () => {

      thumbs.forEach((t) => {
        t.classList.remove('active');
      });

      thumb.classList.add('active');

      mainImage.src = thumb.dataset.image;

    });

  });

  /* VARIANT IMAGE SWITCH */

const variants = JSON.parse(
  document.getElementById('GPVariants').textContent
);

const optionInputs = document.querySelectorAll(
  '.gp-option input[type="radio"]'
);

function getSelectedVariant() {
  const selected = [];

  document.querySelectorAll('.gp-option-block').forEach(block => {
    const checked = block.querySelector('input[type="radio"]:checked');
    selected.push(checked ? checked.value : null);
  });

  return variants.find(v =>
    (!selected[0] || v.option1 === selected[0]) &&
    (!selected[1] || v.option2 === selected[1]) &&
    (!selected[2] || v.option3 === selected[2])
  );
}

function money(cents) {
  return Shopify.formatMoney(
    cents,
    window.theme.settings.moneyFormat
  );
}

function updateVariantData(variant) {

  if (!variant) return;

  document.getElementById('GPVariantId').value = variant.id;

  const price = money(variant.price);

  document.getElementById('GPPrice').innerHTML = price;
  document.getElementById('GPButtonPrice').innerHTML = '→ ' + price;
  
  const stockEl = document.getElementById('GPStock');
  const btn = document.getElementById('GPAddToCart');
  const btnText = document.getElementById('GPAddToCartText');

  const qty = variant.inventory_quantity || 0;

  const soldLastWeek =
    parseInt(
      document.querySelector('.gp-stock-sold')?.textContent
    ) || 0;

  if (variant.available && qty > 0) {

    stockEl.innerHTML = `
      <span class="gp-stock-dot"></span>
      <span class="gp-stock-text">In stock</span>
      <span class="gp-stock-divider">·</span>
      <span class="gp-stock-left">
        ${qty <= 10 ? `Only ${qty} left` : `${qty} available`}
      </span>
      ${
        soldLastWeek > 0
          ? `<span class="gp-stock-divider">·</span>
             <span class="gp-stock-sold">${soldLastWeek} sold in the last week</span>`
          : ''
      }
    `;

    btn.disabled = false;
    btn.classList.remove('disabled');
    btnText.innerHTML = 'ADD TO CART';

  } else {

    stockEl.innerHTML = `
      <span class="gp-stock-out">Out of stock</span>
      ${
        soldLastWeek > 0
          ? `<span class="gp-stock-divider">·</span>
             <span class="gp-stock-sold">${soldLastWeek} sold in the last week</span>`
          : ''
      }
    `;

    btn.disabled = true;
    btn.classList.add('disabled');
    btnText.innerHTML = 'OUT OF STOCK';
  }
}

function updateVariantImage(variant) {
  if (!variant || !variant.featured_image_id) return;


  document.querySelectorAll('.gp-thumb').forEach(thumb => {
    thumb.classList.remove('active');

    if (
      thumb.dataset.imageId ==
      variant.featured_image_id
    ) {
      thumb.classList.add('active');
    }
  });

  
  document.querySelectorAll('.gp-main-image').forEach(img => {
    img.classList.remove('active');

    if (
  img.dataset.imageId ==
  variant.featured_image_id
) {
  img.classList.add('active');

  const mainImage = document.getElementById('GPMainImage');
  if (mainImage) {
    mainImage.src = variant.featured_image;
  }
}
  });
}

optionInputs.forEach(input => {
  input.addEventListener('change', () => {
    const variant = getSelectedVariant();

    if (variant) {
  updateVariantImage(variant);
  updateVariantData(variant);
}
  });
});

const initialVariant = getSelectedVariant();

if (initialVariant) {
  updateVariantData(initialVariant);
}

  /* QUANTITY */

  const minus = document.querySelector('.minus');
  const plus = document.querySelector('.plus');
  const input = document.querySelector('.gp-qty-input');

  if(minus){

    minus.addEventListener('click', () => {

      let val = parseInt(input.value);

      if(val > 1){
        input.value = val - 1;
      }

    });

  }

  if(plus){

    plus.addEventListener('click', () => {

      let val = parseInt(input.value);

      input.value = val + 1;

    });

  }

});